// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import _ from "lodash";
import * as React from "react";

const styles = (): Record<string, CSSProperties> => ({
  notSelectable: {
    mozUserSelect: "none" /* Firefox */,
    msUserSelect: "none" /* IE10+/Edge */,
    userSelect: "none" /* Standard */,
    webkitUserSelect: "none" /* Safari */,
  },
  radioButton: {
    margin: 0,
    padding: 0,
    // width: '35px',
  },
  radioButtons: {
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  radioScale: {
    margin: "0 auto",
    maxWidth: "600px",
  },
  text: {
    bottom: "-6px",
    color: "rgb(59, 59, 59)",
    fontSize: "0.9em",
    overflowWrap: "break-word",
    position: "relative",
    whiteSpace: "pre-wrap",
  },
  textLeft: {
    marginLeft: "1%",
    textAlign: "left",
  },
  textRight: {
    marginRight: "1%",
    textAlign: "right",
  },
  textRights: {
    textAlign: "right",
  },
  textCenter: {
    textAlign: "center",
  },
});

export interface IRadioScale {
  value: string;
  scale: number;
  reversed?: boolean;
  onChange: RadioGroupProps["onChange"];
  positiveText: string;
  negativeText: string;
  averageText?: string;
}

type IProps = IRadioScale & WithStyles<keyof ReturnType<typeof styles>>;

const RadioScale: React.SFC<IProps> = ({
  onChange,
  scale,
  value,
  reversed,
  classes,
  positiveText,
  negativeText,
  averageText = "Average",
}) => {
  const values = reversed ? _.reverse(_.range(scale)) : _.range(scale);
  return (
    <div>
      <div className={classes.radioScale}>
        {reversed ? (
          <Grid
            container={true}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginBottom:"10px",display:"inline-flex"}}
          >
            <div
              className={`${classes.text} ${classes.notSelectable} ${classes.textLeft}`}
            >
              {positiveText}
            </div>
            <div
              className={`${classes.text} ${classes.notSelectable} ${classes.textRight}`}
            >
              {negativeText}
            </div>
          </Grid>
        ) : (
          <Grid
            container={true}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginBottom:"10px",display:"inline-flex"}}
          >
            <div
              className={`${classes.text} ${classes.notSelectable}`}
            >
              {negativeText}
            </div>
             <div
              className={`${classes.text} ${classes.notSelectable} ${classes.textCenter}`}
            >
              {averageText}
            </div>
            <div
              className={`${classes.text} ${classes.notSelectable} ${classes.textRights}`}
            >
              {positiveText}
            </div>
          </Grid>
        )}
        <RadioGroup
          className={classes.radioButtons}
          row={true}
          onChange={onChange}
          value={value}
        >
          {values.map((i) => (
            <Radio
              key={i}
              className={classes.radioButton}
              value={i.toString()}
            />
          ))}
        </RadioGroup>
      </div>
    </div>
  );
};

export default withStyles(styles)(RadioScale);



// WEBPACK FOOTER //
// ./src/shared/components/RadioScale.tsx